import { useMediaQuery } from '@mantine/hooks';

export const useIsCompact = (): boolean =>
    useMediaQuery('(max-width: 62em)', false, { getInitialValueInEffect: false }) ?? false;

export const useIsPhone = (): boolean =>
    useMediaQuery('(max-width: 47.99em)', false, { getInitialValueInEffect: false }) ?? false;

export const useIsWide = (): boolean =>
    useMediaQuery('(min-width: 80em)', false, { getInitialValueInEffect: false }) ?? false;

export const useIsTouch = (): boolean =>
    useMediaQuery('(pointer: coarse)', false, { getInitialValueInEffect: false }) ?? false;

export const useIsMac = (): boolean =>
    typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

export const TOUCH_TARGET = 44;
